import React from 'react';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import CBMediaQuery from '../shared/CBMediaQuery';
import { getCurrentCompany, getStyle } from '../../utils/utils';
import ManufacturerServiceBookEntryList from '../ManufacturerServiceBook/ManufacturerServiceBookEntryList';
import CBButtonWithIconSmall from '../shared/CBButtonWithIconSmall';

class ManufacturerServiceBookLayoutView extends React.Component {
  state = {
    apiKeyExpired: false,
    hasManufacturerServiceBook: true,
  };

  componentDidMount = () => {
    const { user, selectedWorkshopId } = this.props;
    if (selectedWorkshopId) {
      const ws = getCurrentCompany(user, null, selectedWorkshopId, null)
      if (ws.feature_manufacturer_service_book) {
        this.setState({ hasManufacturerServiceBook: true });
        this.fetchAuthenticationStatus();
      } else {
        this.setState({ hasManufacturerServiceBook: false });
      }
    }
  };

  fetchAuthenticationStatus = async () => {
    const { selectedWorkshopId } = this.props;
    if (!selectedWorkshopId) return;

    try {
      const response = await fetch(`/api/1/integrations/oe/is-authentication-expired/?workshop_id=${selectedWorkshopId}`, {
        credentials: 'same-origin',
      });
      if (!response.ok) return;
      const data = await response.json();
      this.setState({ apiKeyExpired: !!data.authentication_expired });
    } catch (e) {
      // Swallow errors and keep default false
    }
  };

  componentDidUpdate(prevProps) {
    const { selectedWorkshopId, user } = this.props;

    if (selectedWorkshopId != prevProps.selectedWorkshopId) {
      const ws = getCurrentCompany(user, null, selectedWorkshopId, null)
      if (ws.feature_manufacturer_service_book) {
        this.setState({ hasManufacturerServiceBook: true });
        this.fetchAuthenticationStatus();
      } else {
        this.setState({ hasManufacturerServiceBook: false });
      }
    }
  };

  handleOEAuth = () => {
    window.location.href = `/api/1/integrations/oe/login/${this.props.selectedWorkshopId}/`;
  };

  render() {
    const {
      history, t, service
    } = this.props;
    const { apiKeyExpired } = this.state;


    if (!this.state.hasManufacturerServiceBook) {
      return (
        <div style={styles.default.welcomeTextContainer}>
          <p className="font-titillium-web-extra-light" style={styles.default.headerTextSub}>
            {t('notAuthorizedManufacturerServiceBook')}
          </p>
        </div>
      );
    }

    return (
      <CBMediaQuery>
        {screenSize => (
          <div>
            {
              apiKeyExpired && (
                <div style={getStyle(screenSize, styles, 'expiredApiKeyContainer')}>
                  <p style={getStyle(screenSize, styles, 'expiredApiKeyText')}>
                    {t('expiredApiKey')}
                  </p>
                  <div>
                    <CBButtonWithIconSmall
                      text={t('authenticateWithOE', {ns: 'WSSettingsView'})}
                      onClick={this.handleOEAuth}
                    />
                  </div>
                </div>
              )
            }
            <ManufacturerServiceBookEntryList apiKeyExpired={apiKeyExpired} />
          </div>
        )}
      </CBMediaQuery>
    );
  }
}

const styles = {
  default: {
    headerTextSub: {
      color: '#FFF',
      fontSize: 20,
      textAlign: 'center',
      margin: 0
    },
    welcomeTextContainer: {
      marginBottom: 16,
      marginTop: 32,
    },
    expiredApiKeyContainer: {
      backgroundColor: '#e74c3c',
      width: '100%',
      padding: 16,
      height: 100,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexDirection: 'column',
      borderBottomLeftRadius: 4,
      borderBottomRightRadius: 4,
    },
    expiredApiKeyText: {
      color: '#FFF',
      fontWeight: 'bold',
      fontSize: 14,
    },
    expiredApiKeyLink: {
      color: '#FFF',
    },
  },
};

function mapStateToProps(state) {
  return {
    service: state.app.service,
    selectedWorkshopId: state.workshop.selectedWorkshop,
    selectedChainId: state.chain.selectedChainId,
    user: state.authUser.user,
  };
}

export default connect(
  mapStateToProps,
  {
  },
)(translate('ManufacturerServiceBookLayoutView')(ManufacturerServiceBookLayoutView));